import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicLongestRoadPlayerStateSchema = z.object({
    longestRoad: z.number().int().nonnegative(),
    hasLongestRoad: z.union([
        z.literal(true),
        z.null()
    ]).exactOptional()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicLongestRoadStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicLongestRoadPlayerStateSchema);
export function validateMechanicLongestRoadState(data) {
    return validateState(mechanicLongestRoadStateSchema, data);
}
const mechanicLongestRoadPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicLongestRoadPlayerStateSchema);
export const mechanicLongestRoadStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicLongestRoadPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
